/**
 * Generated by orval v7.10.0 🍺
 * Do not edit manually.
 * ows-abacus-event
 * OpenAPI spec version: 1.0.0
 */

/**
 * Name of the foreign table the target_id is associated with.
 */
export type TargetType = (typeof TargetType)[keyof typeof TargetType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TargetType = {
  accounting_period: "accounting_period",
  contract: "contract",
  statement_period_adjustment_file: "statement_period_adjustment_file",
  worksheet_payment_contract_advance: "worksheet_payment_contract_advance",
} as const;
